"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyableLicenseData = void 0;
const react_1 = __importDefault(require("react"));
const react_toastify_1 = require("react-toastify");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const LoadingSpinner_1 = __importStar(require("../../../common/js/components/LoadingSpinner"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const LicenseState_1 = require("../../../common/js/enums/LicenseState");
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const string_1 = require("../../../common/js/helper/string");
const translation_1 = require("../../../common/js/helper/translation");
const softwareColumns_1 = require("../../helper/softwareColumns");
const useLicenseState_1 = require("../../hooks/useLicenseState");
const CopyableLicenseData = ({ license, noEllipsis, property }) => {
    const { state, isFetching } = (0, useLicenseState_1.useLicenseState)(license);
    const licenseProperty = license[property];
    if (!!licenseProperty && 'string' !== typeof licenseProperty && 'number' !== typeof licenseProperty) {
        throw new Error(`Only number or string can be displayed but "${property}" is '${typeof licenseProperty}'.`);
    }
    if (isFetching) {
        return react_1.default.createElement(LoadingSpinner_1.default, { style: LoadingSpinner_1.LoadingSpinnerStyle.small });
    }
    if (!licenseProperty) {
        return null;
    }
    if (state !== LicenseState_1.LicenseState.Active) {
        return (0, softwareColumns_1.ellipsisColumn)(licenseProperty.toString(), 5, license, noEllipsis);
    }
    return (react_1.default.createElement("span", { className: "d-flex flex-row align-items-center" },
        licenseProperty,
        react_1.default.createElement(Button_1.default, { className: "znd-assets-table-sub__filename", variant: ButtonVariant_1.default.text, iconRight: Zupicons_1.default.copy, disabled: isFetching, onClick: () => {
                navigator.clipboard.writeText(licenseProperty.toString()).then(() => {
                    react_toastify_1.toast.success((0, translation_1.t)('modal.software_activate_licence.copied', {
                        product_type: (0, string_1.slugifyKey)(license.productType),
                    }));
                });
            } })));
};
exports.CopyableLicenseData = CopyableLicenseData;
